import styled from 'styled-components'
import { Emoji } from '@themenu/ui'

export const EmojiInText = styled(Emoji)`
  margin-top: -4px;
  margin-left: 2px;
  margin-right: 0;
`
